import { NgModule } from '@angular/core';
import { TreeComponent } from './tree.component';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TreeOperationFilterPipe } from './tree-operation-filter.pipe';
import { TooltipModule } from '../tooltip/tooltip.module';
import { DropdownModule } from '../dropdown/dropdown.module';
import { TranslateModule } from '@ngx-translate/core';
import { ToDoCountModule } from '../to-do-count/to-do-count.module';

@NgModule({
  declarations: [TreeComponent, TreeOperationFilterPipe],
  exports: [TreeComponent],
  entryComponents: [TreeComponent],
  imports: [CommonModule, AngularSvgIconModule, TooltipModule, DropdownModule, TranslateModule, ToDoCountModule]
})
export class TreeModule {}

export { TreeComponent };

export * from './tree.types';
